import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import Banner from "./components/Banner";
import { About } from "./components/about";
import { Services } from "./components/services";
import { GallerySlider } from "./components/gallery";
import SponsorsSection from "./components/SponsorsSection";
import { YouTubeSection } from "./components/YouTubeSection";
import { GoogleReviews } from "./components/GoogleReviews";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Banner data={landingPageData.Banner1} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Team data={landingPageData.Team} />
      <SponsorsSection data={landingPageData.Sponsors} />
      <GoogleReviews data={landingPageData.GoogleReviews} />
      <GallerySlider data={landingPageData.Gallery} />
      <YouTubeSection
        videos={[
          "g-9j2_b600s",
          "58I1yr4LMOo",
          "5tjlUU6GYeE",
          "MhsW4qI_ydk",
          "2dOsmGcmzck",
          "CObXk1btKh8",
        ]}
      />
      <Banner data={landingPageData.Banner2} bannerType="Banner2" />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
